import React, { useEffect } from 'react'
import { Popconfirm, Table, Form, Button, Input, Divider, InputNumber, Spin, message } from 'antd'
import Axios from 'axios'
import Title from 'antd/lib/typography/Title'

const EditableContext = React.createContext<any>(null)

const ApiSetting: React.FC<any> = props => {
    const [state, setState] = React.useState({
        data: [] as any[],
        editingKey: '' as any,
        input: {
            type: '',
            apiKey: '',
        },
    })

    const columns = [
        {
            title: 'API Type',
            dataIndex: 'type',
            width: '25%',
            editable: true,
            render: (text: any, record: any) => {
                const editable = isEditing(record)
                return editable ? (
                    <Input
                        value={state.input.type}
                        onChange={evt => {
                            const v = { ...state.input }
                            v.type = evt.target.value
                            setState({
                                ...state,
                                input: v,
                            })
                        }}
                    />
                ) : (
                    text
                )
            },
        },
        {
            title: 'apiKey',
            dataIndex: 'apiKey',
            width: '15%',
            editable: true,
            render: (text: any, record: any) => {
                const editable = isEditing(record)
                return editable ? (
                    <Input
                        value={state.input.apiKey}
                        onChange={evt => {
                            const v = { ...state.input }
                            v.apiKey = evt.target.value
                            setState({
                                ...state,
                                input: v,
                            })
                        }}
                    />
                ) : (
                    text
                )
            },
        },
        {
            title: 'operation',
            dataIndex: 'operation',
            render: (text: any, record: any) => {
                const { editingKey } = state
                const editable = isEditing(record)
                return editable ? (
                    <span>
                        <Button type="link" onClick={() => save(record.key)} style={{ marginRight: 8 }}>
                            Save
                        </Button>
                        <Popconfirm title="Sure to cancel?" onConfirm={() => cancel()}>
                            <Button type="link">Cancel</Button>
                        </Popconfirm>
                    </span>
                ) : (
                    <div>
                        <Button type="link" onClick={() => edit(record.key)} disabled={editingKey !== ''}>
                            Edit
                        </Button>
                        <Button type="link" onClick={() => deleteRow(record._id)} disabled={editingKey !== ''}>
                            Delete
                        </Button>
                    </div>
                )
            },
        },
    ]
    const isEditing = (record: any) => record.key === state.editingKey

    const save = (key: any) => {
        const newData: any[] = [...state.data]
        if (key > -1) {
            newData[Number(key)] = {
                ...newData[Number(key)],
                ...state.input,
            }

            if (newData[Number(key)]._id) {
                Axios.put(`/setting/${newData[Number(key)]._id}`, {
                    type: state.input.type,
                    apiKey: state.input.apiKey,
                }).then(res => {
                    setState({ ...state, data: newData, editingKey: '', input: { type: '', apiKey: '' } })
                })
                console.log('database existing')
            } else {
                Axios.post('/setting', {
                    type: state.input.type,
                    apiKey: state.input.apiKey,
                })
                    .then(res => {
                        newData[Number(key)]._id = res.data._id
                        setState({ ...state, data: newData, editingKey: '', input: { type: '', apiKey: '' } })
                    })
                    .catch(err => console.error(err))
                console.log('database non existing')
            }
        }
    }

    const edit = (key: any) => {
        setState({ ...state, editingKey: key, input: state.data[Number(key)] })
    }

    const deleteRow = (key: any) => {
        Axios.delete(`/setting/${key}`).then(res => {
            const index = state.data.findIndex(x => x._id === key)
            const newArray = [...state.data]
            newArray.splice(index, 1)
            setState({ ...state, data: newArray })
        })
    }

    const cancel = () => {
        const newData: any[] = [...state.data]
        const lastElement = newData[newData.length - 1]
        if (lastElement.apiKey === '' && lastElement.type === '') newData.splice(newData.length - 1, 1)
        setState({ ...state, editingKey: '', input: { type: '', apiKey: '' }, data: newData })
    }

    React.useEffect(() => {
        Axios.get('/setting')
            .then((res: any) => {
                setState(state => ({
                    ...state,
                    data: res.data.map((row: any, index: number) => {
                        row.key = index + ''
                        return row
                    }),
                }))
            })
            .catch(err => {
                console.error(err)
            })
    }, [])

    const handleAdd = () => {
        const { data } = state
        const newData = {
            key: data.length + '',
            type: 'input phase',
            apiKey: 'input apikey',
        }
        setState({
            ...state,
            data: [...data, newData],
            editingKey: data.length + '',
            input: {
                type: 'input phase',
                apiKey: 'input apikey',
            },
        })
    }

    const [angleThresholdRoll, setAngleThresholdRoll] = React.useState(0)
    const [angleThresholdPitch, setAngleThresholdPitch] = React.useState(0)
    const [rssiLevel, setRssiLevel] = React.useState(0)
    const [CSQLevel, setCSQLevel] = React.useState(0)
    const [uplinkSuccessfulRate, setUplinkSuccessfulRate] = React.useState(0)
    const [batteryAlertThreshold, setBatteryAlertThreshold] = React.useState(0)
    const [largeAngleRoll, setLargeAngleRoll] = React.useState(0)
    const [largeAnglePitch, setLargeAnglePitch] = React.useState(0)
    const [tiltingAngleThreshold, setTiltingAngleThreshold] = React.useState(0)
    const [hour, setHour] = React.useState(0)
    const [reportParasLoading, setReportParasLoading] = React.useState(false)

    useEffect(() => {
        setReportParasLoading(true)
        Axios.get('/report-paras')
            .then(res => {
                const {
                    angleThresholdRoll,
                    angleThresholdPitch,
                    rssiLevel,
                    CSQLevel,
                    uplinkSuccessfulRate,
                    batteryAlertThreshold,
                    largeAngleRoll,
                    largeAnglePitch,
                    tiltingAngleThreshold,
                    hour,
                } = res.data

                setAngleThresholdRoll(angleThresholdRoll)
                setAngleThresholdPitch(angleThresholdPitch)
                setRssiLevel(rssiLevel)
                setCSQLevel(CSQLevel)
                setUplinkSuccessfulRate(uplinkSuccessfulRate)
                setBatteryAlertThreshold(batteryAlertThreshold)
                setLargeAngleRoll(largeAngleRoll)
                setLargeAnglePitch(largeAnglePitch)
                setTiltingAngleThreshold(tiltingAngleThreshold)
                setHour(hour)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setReportParasLoading(false)
            })
    }, [])

    const onReportParasSubmit = () => {
        setReportParasLoading(true)
        setReportParasLoading(true)
        Axios.put('/report-paras', {
            angleThresholdRoll,
            angleThresholdPitch,
            rssiLevel,
            CSQLevel,
            uplinkSuccessfulRate,
            batteryAlertThreshold,
            largeAngleRoll,
            largeAnglePitch,
            tiltingAngleThreshold,
            hour,
        })
            .then(res => {})
            .catch(err => console.error)
            .finally(() => {
                setReportParasLoading(false)
                message.success('Update success')
            })
    }

    const [districtLoading, setDistrictLoading] = React.useState(false)
    const [districts, setDistricts] = React.useState<{ name: string }[]>([])
    const [newDistrict, setNewDistrict] = React.useState('')

    const fetchDistrict = () => {
        setDistrictLoading(true)
        Axios.get('/districts')
            .then(res => {
                setDistricts(res.data)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setDistrictLoading(false)
            })
    }

    useEffect(() => {
        fetchDistrict()
    }, [])

    const confirmDeleteDistrict = (name: string) => {
        Axios.delete(`/districts/${name}`, {}).then(res => fetchDistrict())
        message.success('Deleted')
    }

    const addDistrict = () => {
        Axios.post('/districts', { name: newDistrict }).then(res => fetchDistrict())
        setNewDistrict('')
        message.success('Success')
    }

    return (
        <div>
            <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }} disabled={state.editingKey !== ''}>
                Add a row
            </Button>
            <EditableContext.Provider value={props.form}>
                <Table
                    bordered
                    dataSource={state.data}
                    pagination={{
                        onChange: cancel,
                    }}
                    columns={columns}
                />
            </EditableContext.Provider>

            <Divider />

            <Spin spinning={reportParasLoading}>
                <Title level={4}>Report Default Parameters</Title>
                <table cellPadding={5}>
                    <tbody>
                        <tr>
                            <td align="right">Angle Threshold (Roll)</td>
                            <td>
                                <InputNumber
                                    value={angleThresholdRoll}
                                    onChange={value => setAngleThresholdRoll(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Angle Threshold (Pitch)</td>
                            <td>
                                <InputNumber
                                    value={angleThresholdPitch}
                                    onChange={value => setAngleThresholdPitch(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">RSSI Level</td>
                            <td>
                                <InputNumber value={rssiLevel} onChange={value => setRssiLevel(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">CSQ Level</td>
                            <td>
                                <InputNumber value={CSQLevel} onChange={value => setCSQLevel(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Uplink Successful Rate (USR) %</td>
                            <td>
                                <InputNumber
                                    value={uplinkSuccessfulRate}
                                    onChange={value => setUplinkSuccessfulRate(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Battery Alert Threshold</td>
                            <td>
                                <InputNumber
                                    value={batteryAlertThreshold}
                                    onChange={value => setBatteryAlertThreshold(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Large Angle (Roll)</td>
                            <td>
                                <InputNumber value={largeAngleRoll} onChange={value => setLargeAngleRoll(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Large Angle (Pitch)</td>
                            <td>
                                <InputNumber value={largeAnglePitch} onChange={value => setLargeAnglePitch(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Tilting Angle Threshold</td>
                            <td>
                                <InputNumber
                                    value={tiltingAngleThreshold}
                                    onChange={value => setTiltingAngleThreshold(value)}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Hour</td>
                            <td>
                                <InputNumber value={hour} onChange={value => setHour(value)} />
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td>
                                <Button
                                    type="primary"
                                    style={{ width: '100%' }}
                                    onClick={onReportParasSubmit}
                                    disabled={reportParasLoading}
                                >
                                    Submit
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Spin>

            <Divider />

            <Spin spinning={districtLoading}>
                <Title level={4}>Districts</Title>
                <table cellPadding={5}>
                    <tbody>
                        {districts.map(({ name }) => (
                            <tr>
                                <td align="right">{name}</td>
                                <td>
                                    <Popconfirm
                                        title="Are you sure to delete this district?"
                                        onConfirm={e => confirmDeleteDistrict(name)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button
                                            type="primary"
                                            style={{ width: '100%' }}
                                            danger
                                            disabled={reportParasLoading}
                                        >
                                            Delete
                                        </Button>
                                    </Popconfirm>
                                </td>
                            </tr>
                        ))}

                        <tr>
                            <td>
                                <Input
                                    value={newDistrict}
                                    placeholder="Input new district"
                                    onChange={event => {
                                        setNewDistrict(event.target.value)
                                    }}
                                />
                            </td>
                            <td>
                                <Button
                                    type="primary"
                                    style={{ width: '100%' }}
                                    onClick={addDistrict}
                                    disabled={reportParasLoading}
                                >
                                    Add
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}
export default ApiSetting
